import {Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, Input, OnInit, ViewContainerRef} from '@angular/core';
import {SpecialistListItem} from '../../models/specialist-list-item';
import {SpecialistEditModalComponent} from '../specialist-edit-modal/specialist-edit-modal.component';

@Component({
    selector: 'app-specialist-list-preview',
    templateUrl: 'specialist-list-preview.component.html',
    styleUrls: ['specialist-list-preview.component.scss'],
})

export class SpecialistListPreviewComponent implements OnInit {
    @Input() specialist: SpecialistListItem|any;
    @Input() canEdit: boolean = true;

    private factory: ComponentFactory<SpecialistEditModalComponent>;

    private componentRef: ComponentRef<SpecialistEditModalComponent>;

    constructor(
        private viewContainer: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
    ) {
    }

    ngOnInit() {
        this.factory = this.resolver.resolveComponentFactory(SpecialistEditModalComponent);
    }

    onEditClick() {
        /**
         * Динамически инициализируем компонент редактирования карточки оборудования
         */
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
        this.componentRef = this.viewContainer.createComponent(this.factory);

        this.componentRef.instance.specialist = this.rawData;
        this.componentRef.instance.show();

        this.componentRef.instance.onModalClose = () => {
            this.componentRef.destroy();
            this.componentRef = null;
        };
    }

    get rawData() {
        return this.specialist.rawData;
    }
}
